import { isEmail } from './isEmail'

export const replaceEmail = (email: string) => {
  if (isEmail(email)) {
    return `<a href='mailto:${email}' data-readonly>${email}</a>`
  }
  return email
}
